import { HttpInterceptorFn } from '@angular/common/http';

/** CVE-2026-54266: Angular 19 has no framework patch; disable SSR transfer cache on all requests. */
export const noHttpTransferCacheInterceptor: HttpInterceptorFn = (req, next) =>
  next(req.transferCache === false ? req : req.clone({ transferCache: false }));
